import { Link } from "react-router-dom";
import type { Movie } from "@/types";
import RatingBadge from "@/components/base/RatingBadge";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 封面`}
          title={`${movie.title} - 影视影院影视详情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-600/90 text-white text-xs font-label">
          {movie.type === "movie" ? "电影" : "电视剧"}
        </span>
        <span className="absolute top-2 right-2">
          <RatingBadge rating={movie.rating} />
        </span>
      </div>

      <div className="p-3">
        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.genres.slice(0, 2).join(" · ")}
        </p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-400">
          <span>{movie.year}</span>
          <span className="px-1.5 py-0.5 rounded bg-background-200 text-foreground-600">
            {movie.region}
          </span>
        </div>
      </div>
    </Link>
  );
}